import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import useSessionNoteChangeHandler from '@hooks/useSessionNoteChangeHandler';
import ClinicalRadioButtons from '@components/Clinicians/Session/Components/ClinicalRadioButtons';
import useClinicalNotesMeta from '@hooks/useClinicalNotesMeta';

const ImprovementStatusFormItem = () => {
  const { ready } = useTranslation('common');

  const {
    appointment: { appointment_completed: isCompleted, read_only: readonly }
  } = useSessionAppointment();

  const handleNoteChange = useSessionNoteChangeHandler({ field: 'IMPRO' });

  const { getIsFieldRequired, getNoteLabel } = useClinicalNotesMeta();
  const isRequired = getIsFieldRequired('IMPRO');

  return (
    <ClinicalRadioButtons
      key={Number(ready)}
      data-testid="clinical-impro"
      field="IMPRO"
      label={getNoteLabel('IMPRO')}
      items={['Fully Recovered', 'Improving', 'Unchanged', 'Worse']}
      required={isRequired}
      disabled={!!isCompleted || !!readonly}
      onChange={handleNoteChange}
    />
  );
};

export default ImprovementStatusFormItem;
